import request from '../utils/request'

export default {
  /**
   * 功能：分页获取当前用户通知。
   * 参数：params 分页参数，包含 page、pageSize。
   */
  getNotificationPage(params) {
    return request({
      url: '/notification?ac=page',
      method: 'get',
      params
    })
  },

  /**
   * 功能：获取当前用户未读通知数量。
   * 参数：无。
   */
  getNotificationUnreadCount() {
    return request({
      url: '/notification?ac=unreadCount',
      method: 'get'
    })
  },

  /**
   * 功能：将指定通知标记为已读。
   * 参数：data 通知数据，包含 id。
   */
  readNotification(data) {
    return request({
      url: '/notification?ac=read',
      method: 'post',
      data
    })
  },

  /**
   * 功能：将当前用户的全部通知标记为已读。
   * 参数：无。
   */
  readAllNotifications() {
    return request({
      url: '/notification?ac=readAll',
      method: 'post'
    })
  }
}
